module.exports = __webpack_public_path__ + "static/media/twitter.09c04427.svg";